export default __webpack_public_path__ + "static/media/tigerticket-Logo-ticket.f2193be9.png";